export default __webpack_public_path__ + "static/media/nodataland.782a035d.svg";